var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetworkChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.127 10.6883C31.8991 5.77057 38.9808 5.7706 41.753 10.6882L40.9847 11.1214L41.753 10.6882L60.9353 44.7163C63.6587 49.5472 60.168 55.522 54.6223 55.5222H53.2294L53.2462 62.1157C53.2472 62.4824 53.021 62.8115 52.6783 62.9421C52.3356 63.0728 51.9478 62.9776 51.7044 62.7033L45.3334 55.5222H16.2577C10.7119 55.5222 7.22123 49.5473 9.94459 44.7163L29.127 10.6883ZM40.2163 11.5545C38.1189 7.83394 32.761 7.83398 30.6637 11.5545L29.8954 11.1214L30.6637 11.5545L11.4813 45.5826C9.42091 49.2376 12.0618 53.758 16.2577 53.758H45.73C45.9822 53.758 46.2224 53.866 46.3898 54.0547L51.4762 59.7879L51.4631 54.6423C51.4625 54.408 51.5552 54.1831 51.7206 54.0172C51.8861 53.8513 52.1108 53.758 52.3451 53.758H54.6222C58.8181 53.7579 61.459 49.2375 59.3986 45.5826L60.1669 45.1494L59.3986 45.5826L40.2163 11.5545Z",
    fill: "url(#paint0_linear_187_3778)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6046 22.1136C31.7717 21.9312 32.0077 21.8273 32.2551 21.8273H38.6251C38.8725 21.8273 39.1085 21.9312 39.2756 22.1136C39.4427 22.2961 39.5254 22.5404 39.5037 22.7868L37.8965 41.0137C37.8537 41.4989 37.4256 41.8576 36.9404 41.8148C36.4551 41.772 36.0964 41.344 36.1392 40.8587L37.6618 23.5914H33.2184L34.741 40.8587C34.7838 41.344 34.4251 41.772 33.9398 41.8148C33.4545 41.8576 33.0265 41.4989 32.9837 41.0137L31.3765 22.7868C31.3547 22.5404 31.4375 22.2961 31.6046 22.1136ZM35.469 44.9072C34.9252 44.9072 34.4842 45.3481 34.4842 45.8919C34.4842 46.4357 34.9252 46.8766 35.469 46.8766C36.0127 46.8766 36.4537 46.4357 36.4537 45.8919C36.4537 45.3481 36.0127 44.9072 35.469 44.9072ZM32.7201 45.8919C32.7201 44.3738 33.9509 43.1431 35.469 43.1431C36.987 43.1431 38.2178 44.3738 38.2178 45.8919C38.2178 47.41 36.987 48.6407 35.469 48.6407C33.9509 48.6407 32.7201 47.41 32.7201 45.8919Z",
    fill: "url(#paint1_linear_187_3778)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_187_3778",
    x1: 61.8799,
    y1: 7,
    x2: -2.65799,
    y2: 40.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_187_3778",
    x1: 39.5071,
    y1: 21.8273,
    x2: 27.2293,
    y2: 23.8822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkChange);
export default __webpack_public_path__ + "static/media/network-change.673bba04.svg";
export { ForwardRef as ReactComponent };